export default {"src":"/_next/static/media/xas.6b2106f2.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};